module.exports = __webpack_public_path__ + "img/footer.d3699fd1.png";